import array from '@mailobj-browser/front/js/utils/array.js'
import contract, { selectors } from '@mailobj-browser/front/js/contracts/contract.js'
import autofocus from '../autofocus.js'

export default contract({
  [selectors]: {
    '[data-deferred-autofocus]': array([
      autofocus
    ])
  }
})
